export default (function () {
  $.fn.isInViewport = function () {
    var $el = $(this);
    var elTop = $el.offset().top;
    var elHeight = $el.outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    var isMobile = window.matchMedia('(max-width: 768px)').matches;
    var elBottom = elTop + elHeight;
    var visibleTop = Math.max(elTop, viewportTop);
    var visibleBottom = Math.min(elBottom, viewportBottom);
    var visibleHeight = Math.max(0, visibleBottom - visibleTop);
    var visibleElArea = isMobile ? 0.2 : 0.4;
    return visibleHeight >= elHeight * visibleElArea;
  };
  function showIn() {
    $('.show-in').each(function (i) {
      var _this = this;
      if ($(this).isInViewport()) {
        setTimeout(function () {
          $(_this).addClass('is-visible');
        }, "300");
      } else {
        setTimeout(function () {
          $(_this).removeClass('is-visible');
        }, "300");
      }
    });
  }
  if ($(window).scrollTop() === 0) {
    //for page when scroll is on the top
    $('.show-in').each(function (i) {
      if (i === 0) {
        $(this).addClass('is-visible');
      }
    });
    $(window).on("scroll", function () {
      showIn();
    });
  } else {
    //for page when scroll is NOT on the top
    $(window).on("load scroll", function () {
      showIn();
    });
  }
});